export const errorMessage =
  'An error has occurred, please try again or contact mealpal.help@gmail.com for support';
